import { Stack } from '@mantine/core';
import type { DataAccessRequestOut } from '@repo/api-codegen';
import { useState } from 'react';
import { DataAccessRequestApproveModal } from '../../components/DataAccessRequest/DataAccessRequestApproveModal/DataAccessRequestApproveModal';

interface BulkApproveModalProps {
	selected: DataAccessRequestOut[];
	onClose: () => void;
	clearSelection?: () => void;
}

export function BulkApproveModal({
	selected,
	onClose,
	clearSelection,
}: BulkApproveModalProps) {
	const [approvedRequestIds, setApprovedRequestIds] = useState<Set<string>>(
		new Set()
	);

	const handleRequestApproved = (requestId: string) => {
		setApprovedRequestIds((prev) => {
			const next = new Set(prev);
			next.add(requestId);
			if (next.size === selected.length) {
				clearSelection?.();
				onClose();
			}
			return next;
		});
	};

	return (
		<Stack spacing="lg">
			{selected.map((request) => (
				<DataAccessRequestApproveModal
					key={request.id}
					request={request}
					onClose={() => handleRequestApproved(request.id)}
					disabled={approvedRequestIds.has(request.id)}
				/>
			))}
		</Stack>
	);
}
